<div class="resolve-dialog-wrapper">
    <form [formGroup]="resolveForm" class="resolve-dialog-form">
  
      <!-- MODE DROPDOWN -->
      <div class="row">
        <label class="row__label">Resolve Mode</label>
        <p-dropdown
          class="cv-queues-dropdown w-full"
          formControlName="mode"
          [options]="modeOptions"
          optionLabel="label"
          optionValue="value"
          appendTo="body">
        </p-dropdown>
      </div>
  
      <!-- TWO COLUMNS -->
      <div class="columns">
        <!-- LEFT: By Reference Id -->
        <fieldset class="card section"
          [class.section--disabled]="!isReference">
          <div class="section__header">
            <span class="section__title">By Reference Id</span>
          </div>
  
          <div class="section__body">
            <input
              pInputText
              type="text"
              class="w-full"
              formControlName="referenceId"
              placeholder="e.g. 12547.1"
              [ngClass]="{ 'p-invalid': isReference && showErrors('referenceId') }" />
            <small class="p-error" *ngIf="isReference && showErrors('referenceId')">
              Reference Id is required.
            </small>
          </div>
        </fieldset>
  
        <!-- RIGHT: By Dates -->
        <fieldset class="card section"
          [class.section--disabled]="!isDates">
          <div class="section__header">
            <span class="section__title">By Dates</span>
          </div>
  
          <div class="section__body grid">
            <div class="grid-row">
              <span class="p-inputgroup w-full">
                <span class="p-inputgroup-addon">limit</span>
                <input
                  pInputText
                  type="number"
                  class="w-full"
                  formControlName="limit"
                  placeholder="Max records (e.g. 1000)"
                  min="1"
                  [ngClass]="{ 'p-invalid': isDates && showErrors('limit') }" />
              </span>
              <small class="p-error" *ngIf="isDates && showErrors('limit')">
                Please provide a limit number.
              </small>
            </div>
  
            <div class="grid-row dates">
              <p-calendar
                formControlName="startDate"
                [showIcon]="true"
                [appendTo]="'body'"
                dateFormat="yy-mm-dd"
                placeholder="Start Date">
              </p-calendar>
  
              <p-calendar
                formControlName="endDate"
                [showIcon]="true"
                [appendTo]="'body'"
                dateFormat="yy-mm-dd"
                placeholder="End Date">
              </p-calendar>
            </div>
          </div>
        </fieldset>
      </div>
    </form>
  
    <!-- FOOTER -->
    <div class="resolve-dialog-footer">
      <button
        pButton
        class="cv-queues-button p-button-secondary"
        type="button"
        (click)="cancel()"
        label="Cancel">
      </button>
  
      <button
        pButton
        class="cv-queues-button p-button-primary"
        type="button"
        [disabled]="!canResolve"
        (click)="resolve()"
        label="Resolve">
      </button>
    </div>
  </div>